import * as constants from '../constants/actions';

const initialState = {
  pageTitle: 'Diamonds Direct',
  sendLeadDropdownOpen: false,
  sendLeadCard: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case constants.HEADER_TITLE:
      return headerTitle(state, action);
    case constants.HEADER_CLOSE_SEND_LEAD:
      return closeSendLeadDropdown(state, action);
    case constants.HEADER_OPEN_SEND_LEAD:
      return openSendLeadDropdown(state, action);
    default:
      return state;
  }
}

function headerTitle(state, action) {
  return Object.assign({}, state, {
    pageTitle: action.title
  });
}

function closeSendLeadDropdown(state, action) {
  return Object.assign({}, state, {
    sendLeadDropdownOpen: false,
    sendLeadCard: null,
  });
}

function openSendLeadDropdown(state, action) {
  return Object.assign({}, state, {
    sendLeadDropdownOpen: true,
    sendLeadCard: action.card,
  });
}